
import { combineReducers, configureStore } from "@reduxjs/toolkit";
import Auth from "./slices/Auth";

const RootReducers = combineReducers({
    auth: Auth,
})

const store = configureStore({ reducer: RootReducers })
const { dispatch } = store

export { store, dispatch }